import { dispatch, getState } from '@@/store';
import { optCollection } from './BasicOperate';
import { showInitiateDispute, showAbortiveAuction, showContract, showDaYuDispute, } from '@/shared/utils';
import { Modal } from 'antd';
import { SellTransferInfo } from '@/components';
export function winTransferCarColumn(props) {
    const { pageIdentification, record, orderCallback } = props;
    return optCollection({
        pageIdentification,
        record,
        // 争议
        disputeClick: () => {
            opt.handleDispute(record, orderCallback);
        },
        // 流拍
        passInClick: () => {
            opt.handleAbortiveAuction(record, orderCallback);
        },
        // 查看合同
        viewContractClick: () => {
            opt.watchContract(record);
        },
        // 申请向卖家付款
        applySellerCollectionClick: () => {
            opt.applySellerCollectionClick(record, orderCallback);
        },
        // 确认过户
        confirmTransferClick: () => {
            opt.handlePayConfirm(record, orderCallback);
        },
        // 确认交车
        confirmDeliveryClick: () => {
            opt.handlePayConfirm(record, orderCallback);
        },
        // 确认提车
        confirmLiftClick: () => {
            opt.handlePayConfirm(record, orderCallback);
        },
        // 确认过户信息
        confirmTranfInfoClick: () => {
            opt.handlePayConfirm(record, orderCallback);
        },
        // 出价详情
        bidDetailsCilck: () => {
            dispatch.router.push({
                path: '/carManage/offerdetails',
                query: {
                    id: record.auctionId,
                },
            });
        },
    });
}
const opt = {
    // 处理争议
    handleDispute(record, orderCallback) {
        dispatch.initiateDispute.passData({ actionType: record.actionType, orderTag: record.orderTag });
        if (record.actionType === 10 && record.orderTag === 1) {
            showDaYuDispute({
                data: record,
                callback: () => {
                    orderCallback ? orderCallback() : this.commonUpdateTable();
                },
            });
        }
        else {
            showInitiateDispute({
                data: record,
                lubanType: 2,
                callback: () => {
                    orderCallback ? orderCallback() : this.commonUpdateTable();
                },
            });
        }
    },
    // 申请向卖家付款
    applySellerCollectionClick(record, orderCallback) {
        dispatch.transfer.agree({
            data: [record.orderId],
            callback: () => {
                orderCallback ? orderCallback() : this.commonUpdateTable();
            }
        });
    },
    // 处理流拍
    handleAbortiveAuction(record, orderCallback) {
        showAbortiveAuction({
            data: record,
            stateTip: '交付',
            callback: () => {
                orderCallback ? orderCallback() : this.commonUpdateTable();
            },
        });
    },
    // 确认过户 | 确认交车 | 确认过户信息 | 确认提车 (平台化后逻辑推翻，暂不优化了，脑瓜子疼)
    /**
     * transferMode: 过户类型: 3 | 2 | 0 ==> 买家 | 卖家 | 老数据没有售后信息
     * orderTag: 订单标记 1 | 0 : 同步拍 | 不是同步拍
     * actionType: 动作类型 10: 大域  30小圈
     * produceStatus: 售后状态 0 初始 60 买方已经确认验车 70 卖家已经确认交车 80 买方已上传手续
     *
     * @param record
     * @param orderCallback
     */
    handlePayConfirm(record, orderCallback) {
        if (record.actionType === 10 && record.orderTag === 1) {
            // 买家过户
            if (record.transferMode === 3) {
                // produceStatus = 80 ==> 确认过户信息
                if (record.produceStatus === 80) {
                    dispatch.router.push({
                        path: '/OrderManage/ConfirmTransferInfo',
                        query: {
                            id: record.orderId,
                            actionId: record.auctionId,
                            goodsId: record.goodsId,
                            carVin: record.carVin,
                            actionType: record.actionType,
                            orderTag: record.orderTag,
                            saveCurrentPage: getState().transfer.pageCurrent,
                        },
                    });
                }
                // produceStatus = 60 ==> 确认交车
                else if (record.produceStatus === 60) {
                    dispatch.transfer.confirmGiveCar(record).then(() => {
                        const { getTruth } = getState().transfer;
                        if (getTruth) {
                            orderCallback ? orderCallback() : this.commonUpdateTable();
                        }
                        return;
                    });
                }
            }
            // 卖家过户
            else if (record.transferMode === 2) {
                // produceStatus = 60 ==> 上传过户信息
                if (record.produceStatus === 60) {
                    dispatch.transfer.getAuctionBaseInfo(record.auctionId);
                    dispatch.transfer.getUploadPicTempl(record);
                    dispatch.transfer.CONFIRM_REQUEST('seller');
                    dispatch.transfer.CONFIRM_RESOURCE('2');
                    SellTransferInfo({
                        id: record.orderId,
                        goodsId: record.goodsId,
                        transferType: record.transferType,
                        actionType: record.actionType,
                        orderTag: record.orderTag,
                        actionId: record.actionId,
                        propsCallback: () => {
                            orderCallback ? orderCallback() : this.commonUpdateTable();
                        },
                    });
                }
            }
            // 老数据
            else if (record.transferMode === 0) {
                Modal.confirm({
                    title: '是否确认过户？',
                    content: '',
                    onOk() {
                        dispatch.transfer.comfirmTransfer(record);
                    },
                });
            }
        }
        else {
            // 卖家过户
            if (record.transferMode === 2) {
                if (record.produceStatus === 0) {
                    dispatch.transfer.getAuctionBaseInfo(record.auctionId);
                    dispatch.transfer.getUploadPicTempl(record);
                    dispatch.transfer.CONFIRM_REQUEST('seller');
                    dispatch.transfer.CONFIRM_RESOURCE('2');
                    SellTransferInfo({
                        id: record.orderId,
                        goodsId: record.goodsId,
                        transferType: record.transferType,
                        actionType: record.actionType,
                        orderTag: record.orderTag,
                        actionId: record.actionId,
                        propsCallback: () => {
                            orderCallback ? orderCallback() : this.commonUpdateTable();
                        }
                    });
                }
            }
            // 买家过户
            else if (record.transferMode === 3) {
                if (record.produceStatus === 0) {
                    dispatch.transfer.confirmGiveCar(record).then(() => {
                        const { getTruth } = getState().transfer;
                        if (getTruth) {
                            orderCallback ? orderCallback() : this.commonUpdateTable();
                        }
                    });
                }
                else if (record.produceStatus === 80) {
                    dispatch.router.push({
                        path: '/OrderManage/ConfirmTransferInfo',
                        query: {
                            id: record.orderId,
                            actionId: record.auctionId,
                            goodsId: record.goodsId,
                            carVin: record.carVin,
                            actionType: record.actionType,
                            orderTag: record.orderTag,
                            saveCurrentPage: getState().transfer.pageCurrent,
                        },
                    });
                }
            }
            // 老数据
            else if (record.transferMode === 0) {
                Modal.confirm({
                    title: '是否确认过户？',
                    content: '',
                    onOk() {
                        dispatch.transfer.comfirmTransfer(record);
                    },
                });
            }
        }
    },
    // 查看合同
    watchContract(record, orderCallback) {
        showContract({ orderId: record.orderId });
    },
    // 更新表格
    updateTable(index) {
        dispatch.transfer.updateTable(index);
        dispatch.winBiddingCar.getOrderCountInfoApi({});
    },
    // 更新表格并处理翻页
    commonUpdateTable() {
        const { pageCurrent, tableData } = getState().transfer;
        const tableDataLength = tableData.length - 1;
        if (pageCurrent !== 1) {
            if (tableDataLength === 0) {
                this.updateTable(pageCurrent - 1);
            }
            else {
                this.updateTable(pageCurrent);
            }
        }
        else {
            this.updateTable(pageCurrent);
        }
    },
};
